import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store';

Vue.use(VueRouter)
function loadPage(pagePath) {
  return () => import(`@/${pagePath}`);
}

const routes = [

  {
    path: '/',
    name: 'Home',
    component: loadPage('views/Home.vue')
  },
  {
    path: '/:lang?/resetPassword',
    name: 'PasswordReset',
    component: loadPage('views/Password-Reset.vue')
  },
  {
    path: '/geoLimit',
    name: 'geo',
    component: loadPage('views/GeoLimit.vue')
  },
  {
    path: '/404',
    name: '404',
    component: loadPage('views/404.vue')
  },
  {
    path: '/sitedown',
    name: 'down',
    component: loadPage('views/Sitedown.vue')
  },
  {
    path: '/ColgateParkLake',
    name: 'ColgateParkLakeRegulament',
    component: loadPage('views/FileViewer.vue'),
    props: { link: '/files/ColgateParkLakeRegulament.pdf' }
  },
  {
    path: '/.wellknown*',
    name: 'security'
  },
  {
    path: '/*',
    name: 'anyRootPath',
    component: loadPage('views/Home.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'active',
  routes
})

const VUE_APP_SITE_DOMAIN = process.env.VUE_APP_SITE_DOMAIN
let toLoop = true;
router.beforeEach((to, from, next) => {
  // if the user is not authenticated, `next` is called twice
  if (to.name === "security" && toLoop) {
    toLoop = false;
    // router.push(".wellknown/security.txt")
    window.location.href = `${VUE_APP_SITE_DOMAIN}.wellknown/security.txt`;
  } else {
    try {
      const path = window.location.pathname;
      if (path.startsWith("/ColgateLDP2025")) {
        const newPath = path
          .replace(/^\/ColgateLDP2025/, "/ColgateLLDP2025")
        if (newPath !== path) {
          window.location.href = newPath;
        }
      }
      const splitIndex = path.slice(1).indexOf('/') > -1 ? path.slice(1).indexOf('/') + 1 : undefined;
      const campaignName = path.substring(0, splitIndex);
      const campaign = require(`../store/campaigns${campaignName}`).default;
      // console.log("campaign : "+campaign)
      campaign.pageProperties.testing = store.state.pageProperties.testing;
      store.replaceState(campaign);
    } catch (e) {
      next();
      return;
    }

    next();
  }
})

export default router
